import axios from "axios";
const getUserById = async (id) => {
  try {
    const baseUrl = process.env.REACT_APP_API_URL;
    const response = await axios.get(`${baseUrl}/api/users/${id}`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Terjadi kesalahan saat memuat data");
    }
  }
};
export { getUserById };
